export default __webpack_public_path__ + "static/media/expense-tracker.c1d51a91.png";